module.exports = {
  contentModules: {
    oversight: {
      headline: 'Gain oversight for swift decisions',
      blocks: [
        {
          icon: 'draft',
          headline: 'Create drafts',
          content: 'With personal drafts of the rig schedule you can test what-if scenarios and alternative rig optimizations based on different estima-tions and probabilities.',
        },
        {
          icon: 'rigmove',
          headline: 'Smart rig move calculations',
          content: 'Rig moves are automatically added for you based on location and rig-move speed.',
        },
        {
          icon: 'maturity',
          headline: 'Well maturity process',
          content: 'Follow the different states of a well from conceptual to completed and view hard facts related to each well.',
        },
        {
          icon: 'rigcontrol',
          headline: 'Rig control',
          content: 'Overview of all your active rigs with hard facts related to each rig.',
        },
      ],
    },
    seek_and_find: {
      headline: 'Seek, find and edit with ease',
      blocks: [
        {
          icon: 'dragdrop',
          headline: 'Drag & drop optimization',
          content: 'Edit and change the placement of wells with our simple drag & drop functionality. Rig will automatically adapt and optimize the wells and reduce whitespaces accordingly, saving you time in the optimizing processes.',
        },
        {
          icon: 'zoom',
          headline: 'Zoom & scroll',
          content: "With an intuitive and user-friendly interface you can easily navigate your way around the schedule. The zoom let's you zoom in for a detailed view, or zoom out for an overview.",
        },
        {
          icon: 'filter',
          headline: 'Filter and search',
          content: 'With filters and search Rig helps you find the relevant information simple and fast.',
        },
      ],
    },
    stakeholders: {
      headline: 'Involve stakeholders in a beat',
      blocks: [
        {
          icon: 'dashboard',
          headline: 'Admin dashboard',
          content: 'Get an overview of all your incoming requests, deadlines, archived schedules and available drafts in one place.',
        },
        {
          icon: 'roles',
          headline: 'Role administration',
          content: 'Divide the Rig users into 5 roles with different access levels. Based on your company policy users can only view information she has the right too see, or make updates she has permissions to do.',
        },
        {
          icon: 'distribution',
          headline: 'Automated distribution',
          content: 'Distribute your schedule to the right stakeholders in only one click.',
        },
      ],
    },
    planning: {
      headline: null,
      blocks: [
        {
          icon: 'planning',
          headline: 'Well planning',
          content: 'Request new wells for your project and get notified about changes in the rig schedule, as well as reminders about deadlines for making changes to a requested well.',
        },
        {
          icon: 'workflow',
          headline: 'Digital workflow',
          content: 'Complete all your corporate scheduling in one place. Shorten your timelines by assigning parallel tasks in a consistent workflow by automating notifications and electronic approvals.',
        },
        {
          icon: 'export',
          headline: 'Export',
          content: 'Export your schedule to Excel or other formats when needed.',
        },
      ],
    },
    integrations: {
      headline: 'Seamless integrations',
      blocks: [
        {
          icon: 'alwayson',
          headline: 'Always on access',
          content: 'With a clear & readable schedule in the cloud we give you «always on» access to the updated and approved rig schedule to support fact-based decisions.',
        },
        {
          icon: 'integration',
          headline: 'Integration',
          content: 'Rig integrates with other enterprise solutions through your business entity APIs.<br /><br /> <a href="https://agr-rig.redoc.ly/" target="_blank">View API documentation</a>',
        },
        {
          icon: 'sso',
          headline: 'Single sign-on',
          content: 'Rig seamlessly integrates into your companies IT systems. With secure single sign-on technology login is done automatically.',
        },
      ],
    },
  },
};



// WEBPACK FOOTER //
// ./src/config/content.js